import { PauseCancelReasonDto } from "@intelligems/ig-types";

export const PauseItems: PauseCancelReasonDto[] = [
  {
    value: "tooExpensive",
    text: "Too expensive for the value received",
    items: [],
  },
  {
    value: "notSeeingImpact",
    text: "Not seeing the impact we hoped for",
    items: [],
  },
  {
    value: "evaluatingOtherPlatforms",
    text: "Evaluating other platforms/tools",
    items: [],
  },
  {
    value: "productCapabilitiesChallenges",
    text: "Product capabilities or technical challenges",
    items: [],
  },
  {
    value: "insufficientOnboarding",
    text: "Onboarding wasn't sufficient for our team",
    items: [],
  },
  {
    value: "shortTermTesting",
    text: "Only needed for a specific use case or short-term testing",
    items: [],
  },
  {
    value: "businessExternalReasons",
    text: "Business or external reasons",
    items: [],
  },
  {
    value: "other",
    text: "Other",
    items: [],
  },
];
